import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import env from "@/config/env";
import { translations, LANGUAGES, CURRENCIES } from "@/i18n/translations";

const I18nContext = createContext(null);
const LANG_KEY = "kha_lang";
const CUR_KEY = "kha_currency";

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(LANG_KEY) || env.defaultLang);
  const [currency, setCurrencyState] = useState(() => localStorage.getItem(CUR_KEY) || env.defaultCurrency);

  const dir = LANGUAGES.find((l) => l.code === lang)?.dir || "ltr";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [lang, dir]);

  const setLang = (code) => {
    localStorage.setItem(LANG_KEY, code);
    setLangState(code);
  };
  const setCurrency = (code) => {
    localStorage.setItem(CUR_KEY, code);
    setCurrencyState(code);
  };

  const t = useMemo(() => {
    const dict = translations[lang] || translations.en;
    return (key) => dict[key] ?? translations.en[key] ?? key;
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, dir, isRtl: dir === "rtl", t, currency, setCurrency, languages: LANGUAGES, currencies: CURRENCIES }),
    [lang, dir, t, currency]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
